import { Outlet } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

export const Layout = () => (
  <div className="min-h-screen overflow-x-clip bg-sky-soft font-body">
    <Navbar />
    <main>
      <Outlet />
    </main>
    <Footer />
  </div>
);
